import axios, {AxiosInstance} from 'axios'

const instance: AxiosInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_URL,
    headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
    },
})
/*axios.interceptors.request.use(
    (config: any) => {
        const apiToken = localStorage.getItem('listings-app-api-token')
        if (apiToken) {
            config.headers.Authorization = `Bearer ${apiToken}`
        }

        return config
    },
    (err: any) => Promise.reject(err)
)*/
export default instance
